module.exports = __webpack_public_path__ + "img/98_5.85ded743.png";